export function hasPermission(
  availablePermissions: readonly string[] | null | undefined,
  requiredPermission: string | null | undefined,
): boolean {
  if (!requiredPermission) {
    return true;
  }

  if (!availablePermissions || availablePermissions.length === 0) {
    return false;
  }

  if (availablePermissions.includes(requiredPermission) || availablePermissions.includes('*')) {
    return true;
  }

  const requiredParts = requiredPermission.split('.');
  if (requiredParts.length < 2) {
    return false;
  }

  return availablePermissions.includes(`${requiredParts[0]}.*`);
}

export function hasAnyPermission(
  availablePermissions: readonly string[] | null | undefined,
  requiredPermissions: readonly string[] | null | undefined,
): boolean {
  if (!requiredPermissions || requiredPermissions.length === 0) {
    return true;
  }

  return requiredPermissions.some((permission) => hasPermission(availablePermissions, permission));
}
